import { Component, OnInit } from '@angular/core';
import { CookiesService } from '@app/cookies.service';
import { USER_TOKEN, USER_DATA, USER_INFO, ARTIST_INFO, WINDOWSIGHT_APP, APP_CONSTANTS, COOKIE_USER_AVATAR, COOKIE_USER_LOGGED, COOKIE_USER_TYPE, PROMOTION_CODE } from 'src/app/shared/constants';
import firebase from 'firebase/app';

@Component({
  selector: 'app-suspended-account',
  templateUrl: './suspended-account.component.html',
  styleUrls: ['./suspended-account.component.scss']
})
export class SuspendedAccountComponent implements OnInit {

  constructor( ) { }

  ngOnInit() {
  }

  goToSupport() {
    window.open('https://windowsight.com/support/why-has-my-account-been-suspended', '_blank');
  }

  logout() {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        firebase.auth().signOut().then(()=>{
          console.log('firebase logout');
        })
      }
    })
    CookiesService.removeItem(WINDOWSIGHT_APP);
    CookiesService.removeItem(USER_TOKEN);
    CookiesService.removeItem(USER_DATA);
    CookiesService.removeItem(USER_INFO);
    CookiesService.removeItem(ARTIST_INFO); // Needed when returning to Landing
    CookiesService.removeItem(APP_CONSTANTS);
    CookiesService.removeItem(COOKIE_USER_AVATAR);
    CookiesService.removeItem(COOKIE_USER_LOGGED);
    CookiesService.removeItem(COOKIE_USER_TYPE);
    CookiesService.removeItem(PROMOTION_CODE);
    CookiesService.deleteAllCookies();
    CookiesService.clear();
    CookiesService.setUserLogged(false);
    CookiesService.deleteAllCookies();
    window.open('/', '_self');
  }

}
